import { LocalShippingOutlined } from "@mui/icons-material";
import { IconButton, Stack, Tooltip, Zoom } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { ChatInboxPopoverButton } from "components/ChatInboxPopoverButton";
import { CompanyProfileButton } from "components/CompanyProfileNavBarButton";
import { NetworkButton } from "components/NetworkButton";

import { NavBarButtonWrapper } from "../NavBarButtonWrapper";
import { isCompanyRouteActive, isRouteActive, NAV_ROUTES } from "../routes";
import { AdminNavBarItems } from "./AdminNavBarItems";
import { NotificationsNavButton } from "./NotificationsNavButton";

interface CarrierNavBarItemsProps {
  pathName: string;
}

export function CarrierNavBarItems(props: CarrierNavBarItemsProps) {
  const { pathName } = props;
  const navigate = useNavigate();

  return (
    <Stack alignItems="center" color="white" spacing={1}>
      <NavBarButtonWrapper
        isActive={isRouteActive(pathName, NAV_ROUTES.DASHBOARD, true)}
      >
        <Tooltip title="Dashboard" placement="right" TransitionComponent={Zoom}>
          <IconButton
            color="inherit"
            onClick={() => navigate(NAV_ROUTES.DASHBOARD)}
          >
            <LocalShippingOutlined fontSize="large" />
          </IconButton>
        </Tooltip>
      </NavBarButtonWrapper>
      <NotificationsNavButton />
      <NavBarButtonWrapper isActive={isRouteActive(pathName, NAV_ROUTES.CHAT)}>
        <ChatInboxPopoverButton />
      </NavBarButtonWrapper>
      <NavBarButtonWrapper
        isActive={isRouteActive(pathName, NAV_ROUTES.NETWORK)}
      >
        <NetworkButton />
      </NavBarButtonWrapper>
      <NavBarButtonWrapper isActive={isCompanyRouteActive(pathName, "profile")}>
        <CompanyProfileButton />
      </NavBarButtonWrapper>
      <AdminNavBarItems pathName={pathName} />
    </Stack>
  );
}
